import React from "react";
import NavbarDoctorOffice from "../../../NavbarDoctorOffice";
import ModalParametersMedical from "../../modals/ModalParametersMedical";
import useActions from "./use-actions";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import ReactSelect from "react-select";
import ReactTable from "@dhn/components/molecules/data-table";
import EnabledButton from "../../../../../@dhn/components/molecules/button-enabled";
import { differenceWith, isEmpty } from "lodash";
import CardHeaderTabs from "../../../../../@dhn/components/molecules/card-header-tabs";
import ReactFormat from "react-number-format";
import "../../styles-componet-medical-parameter.css";
import LoadingDhn from "../../../../../@dhn/components/Loading/LoadingDhn";
import { formatMedicalParameterRange } from "../../../../../@dhn/shared/utils/format-medical-parameter-range";
import DoctorsOfficePage from "../../../components/DoctorsOfficePage";

export default function MedicalParametersAddOrModify({
  profile,
  user,
  center,
  dataDoctor,
  history,
}) {
  const [
    { state },
    {
      onChange,
      toggle,
      createOrUpdateParameters,
      params,
      onChangeFrequencyAndStatus,
      tableLoading,
    },
  ] = useActions(dataDoctor, history);
  const {
    optionsSpecialitiesByMedical,
    selectedSpecialty,
    optionParametersGroupBySpecialitySelected,
    selectedParameterGroup,
    activeTab,
    dataMedicalParametersToGroups,
    optionsFrequencies,
    loading,
    dataMedicalParametersToGroupsExcludes,
  } = state;

  const dataShowTable = dataMedicalParametersToGroups.find(
    (item) => item?.medicalParameterGroup?.id === activeTab,
  )?.consultoryParametersDetail;

  //dataMedicalParametersToGroupsExcludes se va a utilizar para excluir los grupos que han sido agregado en la BD
  const optionsGroupParameters = differenceWith(
    optionParametersGroupBySpecialitySelected,
    [
      ...dataMedicalParametersToGroupsExcludes,
      ...dataMedicalParametersToGroups,
    ],
    (a, b) => a.id === b.medicalParameterGroup.id,
  );

  console.log("dataShowTabledataShowTable", dataShowTable);

  return (
    <div className="animated fadeIn">
      <LoadingDhn isOpen={loading} />
      <NavbarDoctorOffice
        profile={profile}
        user={user}
        center={center}
        dataDoctor={dataDoctor}
      />
      <ModalParametersMedical
        state={state}
        onChange={onChange}
        toggle={toggle}
      />
      <DoctorsOfficePage icon="fa-sliders" title="Mis Parámetros Médicos">
        <Row form className="d-flex align-items-end">
          <Col md={3}>
            <Label>Médico:</Label>
            <Input
              disabled
              value={`${user.firstName} ${user.lastName}`}
              onChange={(e) => onChange("query", e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Label>{"Especialidad:"}</Label>
            <ReactSelect
              placeholder="Seleccionar Especialidad"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item}
              isDisabled={
                !!params || state.dataMedicalParametersToGroups?.length
              }
              styles={{
                dropdownIndicator: (base) =>
                  !!params ? { ...base, display: "none" } : base,
              }}
              options={optionsSpecialitiesByMedical || []}
              value={isEmpty(selectedSpecialty) ? null : selectedSpecialty}
              onChange={({
                specialtiesMedicalParametersGroup,
                ...rest
              } = {}) => {
                console.log(specialtiesMedicalParametersGroup);

                onChange("dataMedicalParametersToGroups", []);
                onChange("selectedParameterGroup", {});
                onChange("selectedSpecialty", rest);
                onChange(
                  "optionParametersGroupBySpecialitySelected",
                  specialtiesMedicalParametersGroup.map(
                    (item) => item?.medicalParameterGroup,
                  ),
                );
              }}
            />
          </Col>
          <Col md={3}>
            <Label>{"Grupo de Parámetro:"}</Label>
            <ReactSelect
              placeholder="Seleccionar Grupo de Parámetro"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item}
              isDisabled={!optionsGroupParameters?.length}
              options={optionsGroupParameters || []}
              styles={{
                dropdownIndicator: (base, state) =>
                  !!params ? { ...base, display: "none" } : base,
              }}
              onChange={(item) => onChange("selectedParameterGroup", item)}
              value={
                isEmpty(selectedParameterGroup)
                  ? null
                  : selectedParameterGroup
              }
            />
          </Col>
          {!params && (
            <Col md={3}>
              <Button
                color="primary"
                className="btn-color-primary ml-1"
                disabled={isEmpty(selectedParameterGroup)}
                onClick={() => onChange("onActionButtonAdd", true)}
              >
                <i className="fa fa-plus"></i>
                {" Agregar"}
              </Button>
            </Col>
          )}
        </Row>
        <Row form className="mt-4">
          <Col md={12}>
            <Card>
              {!params && (
                <CardHeaderTabs
                  active={activeTab}
                  onClick={(item) => onChange("activeTab", item)}
                  tabs={dataMedicalParametersToGroups.map(
                    (item) => item.medicalParameterGroup,
                  )}
                />
              )}
              <CardBody>
                <ReactTable
                  defaultPageSize={10}
                  data={dataShowTable || []}
                  className="my-component__table -striped -highlight"
                  noDataText="No hay parámetros médicos para mostrar"
                  loading={loading || tableLoading}
                  showPagination={!isEmpty(dataShowTable)}
                  columns={
                    isEmpty(dataShowTable)
                      ? []
                      : [
                          {
                            Header: "Parámetro Médico",
                            accessor: "medicalParameter.name",
                          },
                          {
                            Header: "Unidad de Medida",
                            accessor: "medicalParameter.unitOfMeasurement",
                          },
                          {
                            Header: "Tipo de Parámetro",
                            accessor: "medicalParameter.type.name",
                          },
                          {
                            Header: "Resultados",
                            className: "text-center",
                            Cell: ({
                              original: {
                                medicalParameter: {
                                  typeId = null,
                                  value,
                                  min,
                                  max,
                                } = {},
                              },
                            }) => {
                              switch (typeId) {
                                case 1:
                                  return value === "true"
                                    ? "Positivo"
                                    : "Negativo";
                                case 2:
                                  return value === "true" ? "Si" : "No";
                                case 3:
                                  return formatMedicalParameterRange(min, max, "%");
                                case 4:
                                  return formatMedicalParameterRange(min, max);
                                case 5:
                                case 6:
                                  return "No aplica";
                                default:
                                  return value;
                              }
                            },
                          },
                          {
                            Header: "Valor Optimo",
                            columns: [
                              {
                                Header: "Mínimo",
                                className: "text-right",
                                Cell: ({
                                  original: {
                                    medicalParameter: { min, typeId },
                                  },
                                }) =>
                                  [3, 4].includes(typeId) && (
                                    <ReactFormat
                                      value={min === null || min === undefined ? "" : min}
                                      thousandSeparator={true}
                                      fixedDecimalScale={true}
                                      decimalScale={2}
                                      displayType="text"
                                      suffix={typeId === 3 && "%"}
                                    />
                                  ),
                              },
                              {
                                Header: "Máximo",
                                className: "text-right",
                                Cell: ({
                                  original: {
                                    medicalParameter: { max, typeId },
                                  },
                                }) =>
                                  [3, 4].includes(typeId) && (
                                    <ReactFormat
                                      value={max === null || max === undefined ? "" : max}
                                      thousandSeparator={true}
                                      fixedDecimalScale={true}
                                      decimalScale={2}
                                      displayType="text"
                                      suffix={typeId === 3 && "%"}
                                    />
                                  ),
                              },
                            ],
                          },
                          {
                            Header: "Sexo",
                            accessor: "medicalParameter.gender.name",
                          },
                          {
                            Header: "Frecuencia",
                            accessor: "frequency.name",
                            Cell: ({ original }) => {
                              const { frequency } = original ?? {};

                              return (
                                <div className="w-100 !overflow-visible">
                                  <ReactSelect
                                    options={optionsFrequencies}
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.id}
                                    placeholder="Seleccionar Frecuencia"
                                    value={
                                      isEmpty(frequency) ? null : frequency
                                    }
                                    onChange={(item) =>
                                      onChangeFrequencyAndStatus(
                                        "frequency",
                                        item,
                                        original?.medicalParameterGroup?.id,
                                        original?.medicalParameter?.id,
                                      )
                                    }
                                    menuPosition="fixed"
                                  />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Opciones",
                            width: 110,
                            Cell: ({ original }) => {
                              const { enabled } = original ?? {};
                              return (
                                <EnabledButton
                                  status={enabled}
                                  onClick={() =>
                                    onChangeFrequencyAndStatus(
                                      "enabled",
                                      !enabled,
                                      original?.medicalParameterGroup?.id,
                                      original?.medicalParameter?.id,
                                    )
                                  }
                                />
                              );
                            },
                          },
                        ]
                  }
                />
              </CardBody>
              <CardFooter>
                <Row form>
                  <Col>
                    {!isEmpty(dataShowTable) ? (
                      <Button
                        color="success"
                        className="btn-color-success ml-1"
                        onClick={() => createOrUpdateParameters()}
                      >
                        {loading ? (
                          <>
                            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            {" Cargando..."}
                          </>
                        ) : (
                          <>
                            <i className="fa fa-plus" />
                            {!params ? " Agregar" : " Modificar"}
                          </>
                        )}
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Col>
                  <Button
                    color="danger"
                    className="btn-color-danger"
                    onClick={() => history.goBack()}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                    {" Cancelar"}
                  </Button>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </DoctorsOfficePage>
    </div>
  );
}
